import { Component } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-performance-load-testing",
  templateUrl: "./performance-load-testing.component.html",
  styleUrls: ["./performance-load-testing.component.less"],
})
export class PerformanceLoadTestingComponent {
 constructor() {}
  
  expandMenu(reference: HTMLElement) {
    reference.classList.remove("collapsed");
  }

  collapseMenu(reference: HTMLElement) {
    reference.classList.add("collapsed");
  }

}
